module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/64Un0g/tc-custom/9780544230866.jpg?1737157400231",
      "alt": "This image is the cover for the book Why Read the Classics?"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Why Read the Classics?\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("This collection of essays by the acclaimed author of "), _c('i', [_vm._v("Cosmicomics")]), _vm._v(" offers a fascinating, personal journey through some of literature’s greatest works.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Classics, according to Italo Calvino, are not only works of enduring cultural value, but also personal touchstones. They are the books we are always rereading in order to understand our world and ourselves. Here, Calvino introduces more than thirty works from his own ideal library in essays of warmth, humor, and striking insight. He discusses great authors ranging from Homer to Jorge Luis Borges, and from Charles Dickens to the Persian folklorist Nezami."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Whether tracing the links between Ovid’s Metamorphoses and Alain Robbe-Grillet’s objectivity, discovering the origins of science fiction in the writings of Cyrano de Bergerac, or convincing us that the Italian novelist Carlo Emilio Gadda’s works are like artichokes, Calvino offers a new perspective on beloved favorites and introduces us to hidden gems."), _c('br'), _vm._v(" "), _c('br'), _c('b', [_vm._v("“This book serves as a welcome reminder that the great works are great because they can mean so much to readers, and Calvino is a most knowledgeable guide to all the best destinations.”—"), _c('i', [_vm._v("San Francisco Chronicle")])])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Italo Calvino\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Houghton Mifflin Harcourt\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0